import {
  Box,
  Button,
  MenuItem,
  Menu,
  CircularProgress,
  Skeleton,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./LeadReportCreation.module.css";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import CancelBtn from "../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../components/Buttons/SaveBtn";
import { useLocation, useNavigate } from "react-router-dom";
import SaveReportPopup from "../SaveReportPopup/SaveReportPopup";
import CancelModal from "../../../../../components/CancelModal/CancelModal";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PaymentStatusToggle from "./Toggle";
import { getSubDomainAccessStatus } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import {
  findCountryByName,
  formatAmount,
  getMonths,
  getYears,
} from "../../../../../components/CommonFunctions/CommonFunctions";
import moment from "moment";
import BarChart from "../../../Dashboard/components/BarChart/BarChart";
import { useDispatch } from "react-redux";
import { useCountries } from "use-react-countries";
import {
  getReportById,
  getReportData,
  resetReportStatuses,
  resetWholeReportData,
  saveReport,
} from "../../service/reportsSlice";
import RevenuePaidTab from "./RevenuePaidTab";
import RevenueOverdueTab from "./RevenueOverdueTab";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import TableSkeleton from "../../../../../components/Skeletons/TableSkeleton";
import dayjs from "dayjs";
import AutoCompleteFilter from "../Filters/AutoCompleteFilter";
import clearFilterIcon from "../../../../../assets/images/clearFilter.svg";
import downloadIcon from "../../../../../assets/images/report-download.svg";
import FilterChips from "../../../../../components/FilterDrawer/FilterChips/FilterChips";
import accordionDown from "../../../../../assets/images/accordion-down.svg";
import { DownloadReport } from "../../service/reports.request";
import DashboardSkeleton from "../../../../../components/Skeletons/DashboardSkeleton";
import PageBackBtn from "../../../../../components/Buttons/PageBackBtn";
import RevenuePendingTab from "./RevenuePendingTab";
import YearMonthSelector from "./MultiSelectMonthYear";

interface CheckedBranch {
  id: string;
  branchName: string;
}
interface CheckedCountry {
  name: string;
}
interface CheckedCourse {
  id: string;
  courseName: string;
}
interface CheckedBatch {
  id: string;
  batchName: string;
}
const RevenueReportCreation = (props: any) => {
  const { add } = props;
  const auth = useAuthUser();
  const user = auth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userById } = useSelector((state: any) => state.userDetails);
  const [hoveredYear, setHoveredYear] = useState<number | null>(null);
  // const [selectedMonths, setSelectedMonths] = useState<any>({});
  const [selectedMonths, setSelectedMonths] = useState<any>(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonthName = currentDate.toLocaleString("default", {
      month: "long",
    }); // "November"

    return {
      [currentYear]: [currentMonthName],
    };
  });
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const activeInstitute = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const { countries } = useCountries();
  const {
    saveReportLoading,
    saveReportSuccess,
    reportWholeData,
    reportDataloading,
    reportById,
    reportByIdLoading,
  } = useSelector((state: any) => state.reports);
  const branches = useSelector((state: any) => state.branch.branchList);
  const courses = useSelector((state: any) => state.courses.courses);
  const batchList = useSelector((state: any) => state.batch.batchList);
  const filteredCountries = countries?.filter((country: any) =>
    branches?.some((branch: any) =>
      hasAllBranchAccess
        ? branch.country === country.name
        : branch.country === country.name && branch.id === userById?.branchId
    )
  );
  const typeOptions = [
    { id: "ACTIVE", value: "Active" },
    { id: "LOST", value: "Lost" },
  ];

  const [reportType, setReportType] = useState<string>("MONTH_LEVEL");
  const [active, setActive] = useState<number>(0);
  const [showFilters, setShowFilters] = useState<boolean>(add ? true : false);
  const [checkedCountry, setCheckedCountry] = useState<CheckedCountry[]>([]);
  const [appliedCountry, setAppliedCountry] = useState<CheckedCountry[]>([]);
  const [checkedBranches, setCheckedBranches] = useState<CheckedBranch[]>([]);
  const [checkedCourses, setCheckedCourses] = useState<CheckedCourse[]>([]);
  const [checkedBatches, setCheckedBatches] = useState<CheckedBatch[]>([]);
  const [selectedMonth, setSelectedMonth] = useState<any[]>([]);
  const [selectedYear, setSelectedYear] = useState<any[]>([]);

  const [collapseGraph, setCollapseGraph] = useState<boolean>(
    add ? true : false
  );
  const [openSaveReportPopup, setOpenSaveReportPopup] = useState(false);
  const [cancel, setCancel] = useState<boolean>(false);
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [description, setDescription] = React.useState<string>("");
  const [reportName, setReportName] = React.useState<string>("");
  const [includeAdditionaPayment, setIncludeAdditionalPayment] =
    useState(false);
  const [selectedType, setSelectedType] = useState<any[]>([...typeOptions]);

  const coursesList = courses?.filter((item: any) => item?.status === "ACTIVE");
  const [dontRun, setDontRun] = useState(false);

  const filteredBranches = branches?.filter((branch: any) => {
    const matchesBranchAccess =
      hasAllBranchAccess || branch?.id === userById?.branchId;

    const matchesCheckedCountry =
      checkedCountry?.length === 0 ||
      checkedCountry?.some((c) => c?.name === branch?.country);

    return matchesBranchAccess && matchesCheckedCountry;
  });

  const filteredBatch = batchList?.filter((batch: any) => {
    const matchesBranchAccess =
      hasAllBranchAccess || batch?.branchId === userById?.branchId;

    const isValidBatch =
      batch.batchConductType === "REGULAR_BATCH" &&
      /* batch.batchStatus === 'COMPLETED' && */
      batch.batchStatus !== "CANCELLED" &&
      batch.status === "ACTIVE";

    const matchesSelectedBranches =
      checkedBranches?.length === 0 ||
      checkedBranches?.some((branch: any) => branch?.id === batch?.branchId);
    const matchesSelectedCourses =
      checkedCourses?.length === 0 ||
      checkedCourses?.some((item: any) => item?.id === batch?.courseId);

    return (
      matchesBranchAccess &&
      isValidBatch &&
      matchesSelectedBranches &&
      matchesSelectedCourses
    );
  });

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (value: any) => {
    setAnchorEl(null);
  };
  const handleReportType = (value: any) => {
    if (value) setReportType(value);
    setCheckedCountry([]);
    setCheckedBranches([]);
    setCheckedBatches([]);
    setCheckedCourses([]);
    setSelectedYear([]);
    setSelectedMonth([]);
    setSelectedType([...typeOptions]);
    setAnchorEl(null);
    setIncludeAdditionalPayment(false);
    setSelectedMonths({});
  };

  const onBranchChange = React.useCallback((event: any, items: any) => {
    setCheckedBranches((prev) => {
      const newItemsMap = new Map(items?.map((item: any) => [item.id, item]));

      return prev
        ?.filter((item) => newItemsMap.has(item.id))
        ?.concat(
          items.filter(
            (item: any) => !prev.some((prevItem) => prevItem.id === item.id)
          )
        );
    });
    setCheckedCourses([]);
    setCheckedBatches([]);
  }, []);

  const onSingleBranchChange = React.useCallback(
    (event: any, value: any | any[]) => {
      if (Array.isArray(value) && value?.length > 1) {
        setCheckedBranches([value[value.length - 1]]);
      } else {
        setCheckedBranches(value ? value : []);
      }
      setCheckedBatches([]);
    },
    []
  );

  const onCountryChange = React.useCallback(
    (event: any, value: any | any[]) => {
      if (Array.isArray(value) && value?.length > 1) {
        setCheckedCountry([value[value.length - 1]]);
      } else {
        setCheckedCountry(value ? value : []);
      }
      setCheckedBranches([]);
      setCheckedBatches([]);
      setCheckedCourses([]);
    },
    []
  );
  // const onYearChange = React.useCallback((event: any, value: any) => {
  //   if (Array.isArray(value) && value?.length > 1) {
  //     setSelectedYear([value[value.length - 1]]);
  //   } else {
  //     setSelectedYear(value ? value : []);
  //   }
  // }, []);

  // const onMonthChange = React.useCallback((event: any, value: any) => {
  //   if (Array.isArray(value) && value?.length > 1) {
  //     setSelectedMonth([value[value.length - 1]]);
  //   } else {
  //     setSelectedMonth(value ? value : []);
  //   }
  // }, []);

  // const onBatchChange = React.useCallback((event: any, value: any | any[]) => {
  //   if (Array.isArray(value) && value?.length > 1) {
  //     setCheckedBatches([value[value.length - 1]]);
  //   } else {
  //     setCheckedBatches(value ? value : []);
  //   }
  // }, []);

  // const onCourseChange = React.useCallback((event: any, value: any | any[]) => {
  //   if (Array.isArray(value) && value?.length > 1) {
  //     setCheckedCourses([value[value.length - 1]]);
  //   } else {
  //     setCheckedCourses(value ? value : []);
  //   }
  //   setCheckedBatches([]);
  // }, []);

  const onYearChange = React.useCallback((event: any, items: any[]) => {
    setSelectedYear((prev: any[]) => {
      const newItemsMap = new Map(items?.map((item: any) => [item, item]));
      return prev
        ?.filter((item) => newItemsMap.has(item))
        ?.concat(
          items.filter(
            (item: any) => !prev.some((prevItem) => prevItem === item)
          )
        );
    });
  }, []);

  const onMonthChange = React.useCallback((event: any, items: any[]) => {
    setSelectedMonth((prev: any[]) => {
      const newItemsMap = new Map(items?.map((item: any) => [item, item]));
      return prev
        ?.filter((item) => newItemsMap.has(item))
        ?.concat(
          items.filter(
            (item: any) => !prev.some((prevItem) => prevItem === item)
          )
        );
    });
  }, []);

  const onBatchChange = React.useCallback((event: any, items: any[]) => {
    setCheckedBatches((prev: any[]) => {
      const newItemsMap = new Map(items?.map((item: any) => [item.id, item]));
      return prev
        ?.filter((item) => newItemsMap.has(item.id))
        ?.concat(
          items.filter(
            (item: any) => !prev.some((prevItem) => prevItem.id === item.id)
          )
        );
    });
  }, []);

  const onCourseChange = React.useCallback((event: any, items: any[]) => {
    setCheckedCourses((prev: any[]) => {
      const newItemsMap = new Map(items?.map((item: any) => [item.id, item]));
      return prev
        ?.filter((item) => newItemsMap.has(item.id))
        ?.concat(
          items.filter(
            (item: any) => !prev.some((prevItem) => prevItem.id === item.id)
          )
        );
    });

    // Reset batches when course changes
    setCheckedBatches([]);
  }, []);

  const onCancel = () => {
    setCancel(false);
  };

  const noCancelModal = () => {
    setCancel(false);
  };

  const yesCancelModal = () => {
    setCancel(false);
    dispatch(resetWholeReportData());
    location?.state?.from === "RecentReports"
      ? navigate("/app/Reports/RecentReports")
      : location?.state?.from === "CreatedByMe"
      ? navigate("/app/Reports/CreatedByMe")
      : navigate("/app/Reports/AllReports");
  };

  const pageBack = () => {
    dispatch(resetWholeReportData());
    location?.state?.from === "RecentReports"
      ? navigate("/app/Reports/RecentReports")
      : location?.state?.from === "CreatedByMe"
      ? navigate("/app/Reports/CreatedByMe")
      : navigate("/app/Reports/AllReports");
  };

  const handleResetFilter = () => {
    setCheckedBranches([]);
    setCheckedBatches([]);
    setCheckedCourses([]);
    setCheckedCountry([]);
    setSelectedMonth([]);
    setSelectedYear([]);
    setSelectedType([...typeOptions]);
    setSelectedMonths({});
  };

  const monthNameToNumber: Record<string, number> = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  };

  const convertMonthYearData = (data: Record<string, string[]>) => {
    return Object.entries(data).map(([year, months]) => ({
      year: Number(year),
      month: months.map((m) => monthNameToNumber[m]).filter(Boolean),
    }));
  };

  const numberToMonthName = Object.fromEntries(
    Object.entries(monthNameToNumber).map(([name, num]) => [num, name])
  );

  const handleFilterApply = () => {
    const isEmpty = Object.values(selectedMonths).every(
      (months) => !Array.isArray(months) || months.length === 0
    );
    if (reportType === "") {
      dispatch(
        setToastNotification({
          message: "Please select a report type",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (checkedCountry?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select a country",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (checkedBranches?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select branch filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (selectedType?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select type",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (reportType === "BATCH_LEVEL" && checkedCourses?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select course filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (reportType === "BATCH_LEVEL" && checkedBatches?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select batch filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (reportType === "MONTH_LEVEL" && isEmpty) {
      dispatch(
        setToastNotification({
          message: "Please select month and Year filter",
          type: "error",
          snackOpen: true,
        })
      );
    }
    // else if (reportType === "MONTH_LEVEL" && selectedYear?.length === 0) {
    //   dispatch(
    //     setToastNotification({
    //       message: "Please select year filter",
    //       type: "error",
    //       snackOpen: true,
    //     })
    //   );
    // }
    else {
      const data: any = {
        reportType: "REVENUE",
        instituteId: activeInstitute?.id,
        generateReports: true,
        reportSubType: reportType,
        branchCountry: checkedCountry?.[0]?.name,
        branchId: checkedBranches?.map((d: any) => d?.id),
        includeRandomPayment: includeAdditionaPayment,
        enquiryStatus: selectedType?.map((type) => type.id),
      };

      if (reportType === "BATCH_LEVEL") {
        data.courseId = checkedCourses?.map((d: any) => d?.id);
        data.batchId = checkedBatches?.map((d: any) => d?.id);
      }

      if (reportType === "MONTH_LEVEL") {
        // data.month = selectedMonth[0]?.id;
        // data.year = selectedYear[0];
        // data.month = selectedMonth?.map((d: any) => d?.id);
        // data.year = selectedYear;
        const filtered = convertMonthYearData(selectedMonths)?.filter(
          (item: any) => Array.isArray(item.month) && item.month.length > 0
        );
        data.monthYear = filtered;
      }
      dispatch<any>(getReportData(data));
    }
  };

  const handleSaveClick = async (event: any) => {
    event.preventDefault();

    const appliedFilterCopy = [...reportWholeData.appliedFilter];

    if (includeAdditionaPayment) {
      appliedFilterCopy.push({ includeRandomPayment: true });
    }

    const updatedReportData = {
      ...reportWholeData,
      appliedFilter: appliedFilterCopy,
    };

    const data = {
      instituteId: activeInstitute?.id,
      name: reportName,
      category: "REVENUE",
      description: description,
      reportData: updatedReportData,
      createdById: user?.institute[0]?.id,
      createdByName: `${user?.institute[0]?.firstName} ${user?.institute[0]?.lastName}`,
    };
    dispatch<any>(saveReport(data));
  };

  const handleDownload = () => {
    const data = {
      action: "DOWNLOAD",
      reportType: "REVENUE",
      reportData: {
        paymentData: reportWholeData?.paymentData,
        overDue: reportWholeData?.overDue,
        pendingdata: reportWholeData?.pendingdata,
      },
    };
    setDownloadLoading(true);
    DownloadReport(data)
      .then((res: any) => {
        const blob = base64ToBlob(
          res?.data?.data?.fileBase64String,
          "application/vnd.ms-excel"
        );
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "RevenueReport.xlsx";
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        dispatch(
          setToastNotification({
            message: "Congratulations! Report is successfully downloaded.",
            type: "success",
            snackOpen: true,
          })
        );
        setDownloadLoading(false);
      })
      .catch((err: any) => {
        setDownloadLoading(false);
      });
  };

  const base64ToBlob = (base64Data: string, contentType: any) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const findNamesbyId = (fieldName: any, id: string) => {
    if (fieldName === "COURSE" && id) {
      const courseName = courses?.filter(
        (d: any) =>
          d?.id.toString().toLowerCase() === id.toString().toLowerCase()
      );
      return courseName && courseName[0]?.courseName;
    } else if (fieldName === "BATCH" && id) {
      const batchName = batchList?.filter(
        (d: any) =>
          d?.id.toString().toLowerCase() === id.toString().toLowerCase()
      );

      return batchName && batchName[0]?.batchName;
    } else if (fieldName === "BRANCH" && id) {
      const branchName = filteredBranches?.filter((d: any) => d?.id === id);
      return branchName && branchName[0]?.branchName;
    }
  };

  // useEffect(() => {
  //   if (add) {
  //     const getBranch = branches?.find(
  //       (item: any) => item?.id === userById?.branchId
  //     );

  //     const currentMonth = dayjs().month() + 1;
  //     const currentYear = dayjs().year();
  //     const data = {
  //       reportType: "REVENUE",
  //       instituteId: activeInstitute?.id,
  //       generateReports: true,
  //       branchId: "ALL",
  //       reportSubType: "MONTH_LEVEL",
  //       branchCountry: getBranch?.country,
  //       // month: currentMonth,
  //       // year: currentYear,
  //       monthYear: convertMonthYearData(selectedMonths),
  //       includeRandomPayment: includeAdditionaPayment,
  //       enquiryStatus: ["ACTIVE", "LOST"],
  //     };

  //     if (hasAllBranchAccess) {
  //       dispatch<any>(getReportData(data));
  //     } else {
  //       const ownBranchData = {
  //         reportType: "REVENUE",
  //         reportSubType: "MONTH_LEVEL",
  //         instituteId: activeInstitute?.id,
  //         generateReports: true,
  //         branchCountry: getBranch?.country,
  //         branchId: filteredBranches?.map((d: any) => {
  //           return d?.id;
  //         }),
  //         // month: currentMonth,
  //         // year: currentYear,
  //         monthYear: convertMonthYearData(selectedMonths),
  //         includeRandomPayment: includeAdditionaPayment,
  //       };
  //       dispatch<any>(getReportData(ownBranchData));
  //     }
  //   } else {
  //     const pathname = window.location.pathname;
  //     const reportId = pathname.substring(pathname.lastIndexOf("/") + 1);
  //     dispatch<any>(getReportById(reportId));
  //   }
  // }, [branches, userById]);
  // 1️⃣ Run initial data load ONCE when all required data is ready
  useEffect(() => {
    if (!branches?.length || !userById?.branchId) return; // wait until both exist

    if (add) {
      const getBranch = branches.find(
        (item: any) => item.id === userById.branchId
      );

      const data = {
        reportType: "REVENUE",
        instituteId: activeInstitute?.id,
        generateReports: true,
        branchId: "ALL",
        reportSubType: "MONTH_LEVEL",
        branchCountry: getBranch?.country,
        monthYear: convertMonthYearData(selectedMonths),
        includeRandomPayment: includeAdditionaPayment,
        enquiryStatus: ["ACTIVE", "LOST"],
      };

      if (hasAllBranchAccess) {
        dispatch<any>(getReportData(data));
      } else {
        const ownBranchData = {
          ...data,
          branchId: filteredBranches?.map((d: any) => d.id),
        };
        dispatch<any>(getReportData(ownBranchData));
      }
    } else {
      const reportId = window.location.pathname.split("/").pop();
      if (reportId) {
        dispatch<any>(getReportById(reportId));
      }
    }

    // ✅ Run only once on mount when data is ready
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [add, branches?.length, userById?.branchId]);

  // useEffect(() => {
  //   if (
  //     reportWholeData?.appliedFilter ||
  //     reportById?.reportData?.appliedFilter
  //   ) {
  //     const dataFromNavigateion = add
  //       ? reportWholeData?.appliedFilter
  //       : reportById?.reportData?.appliedFilter;
  //     const branchIdArray = dataFromNavigateion?.find(
  //       (item: any) => item.branchId
  //     )?.branchId;
  //     const batchIdArray = dataFromNavigateion?.find(
  //       (item: any) => item.batchId
  //     )?.batchId;
  //     const courseIdArray = dataFromNavigateion?.find(
  //       (item: any) => item.courseId
  //     )?.courseId;
  //     const countryCheck = dataFromNavigateion?.find(
  //       (item: any) => item.branchCountry
  //     )?.branchCountry;
  //     const months = getMonths();
  //     // const month = dataFromNavigateion?.find((item: any) => item.month)?.month;
  //     const month = dataFromNavigateion?.find(
  //       (item: any) => item.durationFilter
  //     )?.durationFilter;

  //     const year = dataFromNavigateion?.find((item: any) => item.year)?.year;

  //     const reportSubType = add
  //       ? reportWholeData?.type
  //       : reportById?.reportData?.type;

  //     if (!add) {
  //       const randomPaymentIncluded = dataFromNavigateion?.find(
  //         (item: any) => item.includeRandomPayment
  //       )?.includeRandomPayment;
  //       setIncludeAdditionalPayment(randomPaymentIncluded);
  //     }
  //     const filterBranches = branches?.filter(
  //       (item: any) => item?.country === countryCheck
  //     );
  //     const filterBatches = batchList?.filter(
  //       (batch: any) =>
  //         batch.batchConductType === "REGULAR_BATCH" &&
  //         /* batch.batchStatus === 'COMPLETED' && */
  //         batch.batchStatus !== "CANCELLED" &&
  //         batch.status === "ACTIVE" &&
  //         (hasAllBranchAccess || batch?.branchId === userById?.branchId) &&
  //         filterBranches?.some((branch: any) => branch.id === batch.branchId)
  //     );
  //     if (month && !add) {
  //       // const selectedMonthObj = months?.find((m) => m.id === month);
  //       // if (selectedMonthObj) {
  //       //   setSelectedMonth([selectedMonthObj]);
  //       // }
  //       const grouped = month?.reduce((acc: any, item: any) => {
  //         const [month, year] = item.split("-").map(Number);
  //         const found = acc.find((entry: any) => entry.year === year);
  //         if (found) {
  //           found.month.push(month);
  //         } else {
  //           acc.push({ year, month: [month] });
  //         }
  //         return acc;
  //       }, []);

  //       setSelectedMonths({ monthYear: grouped });
  //     }
  //     // if (year) {
  //     //   setSelectedYear([year]);
  //     // }

  //     if (reportSubType) {
  //       setReportType(reportSubType);
  //     }
  //     if (countryCheck) {
  //       setCheckedCountry([{ name: countryCheck }]);
  //       setAppliedCountry([{ name: countryCheck }]);
  //     }

  //     if (
  //       branchIdArray === "ALL" ||
  //       branchIdArray?.length === filterBranches?.length
  //     ) {
  //       const alllBranches =
  //         filterBranches?.map((d: any) => {
  //           return { id: d?.id, branchName: d?.branchName };
  //         }) || [];
  //       setCheckedBranches([...alllBranches]);
  //     } else {
  //       const aa = branchIdArray?.map((d: any) => {
  //         return { id: d, branchName: findNamesbyId("BRANCH", d) };
  //       });
  //       setCheckedBranches(aa);
  //     }
  //     if (
  //       batchIdArray === "ALL" ||
  //       batchIdArray?.length === filterBatches?.length
  //     ) {
  //       const alllBatches =
  //         filterBatches?.map((d: any) => {
  //           return { id: d?.id, batchName: d?.batchName };
  //         }) || [];
  //       setCheckedBatches([...alllBatches]);
  //     } else {
  //       const aa = batchIdArray?.map((d: any) => {
  //         return { id: d, batchName: findNamesbyId("BATCH", d) };
  //       });
  //       setCheckedBatches(aa);
  //     }

  //     if (courseIdArray === "ALL") {
  //       const alllCourse =
  //         coursesList?.map((d: any) => {
  //           return { id: d?.id, courseName: d?.courseName };
  //         }) || [];
  //       setCheckedCourses([...alllCourse]);
  //     } else {
  //       const aa = courseIdArray?.map((d: any) => {
  //         return { id: d, courseName: findNamesbyId("COURSE", d) };
  //       });
  //       setCheckedCourses(aa);
  //     }
  //     setActive(0);
  //   }
  // }, [
  //   reportWholeData,
  //   reportById,
  //   add,
  //   userById,
  //   branches,
  //   batchList,
  //   courses,
  // ]);
  // 2️⃣ Handle report data AFTER it is fetched
  useEffect(() => {
    const appliedFilter = add
      ? reportWholeData?.appliedFilter
      : reportById?.reportData?.appliedFilter;

    if (!appliedFilter) return;
    const dataFromNavigation = appliedFilter;
    const branchIdArray = dataFromNavigation?.find(
      (item: any) => item.branchId
    )?.branchId;
    const batchIdArray = dataFromNavigation?.find(
      (item: any) => item.batchId
    )?.batchId;
    const courseIdArray = dataFromNavigation?.find(
      (item: any) => item.courseId
    )?.courseId;
    const countryCheck = dataFromNavigation?.find(
      (item: any) => item.branchCountry
    )?.branchCountry;
    const month = dataFromNavigation?.find(
      (item: any) => item.durationFilter
    )?.durationFilter;
    const reportSubType = add
      ? reportWholeData?.type
      : reportById?.reportData?.type;

    if (!add) {
      const randomPaymentIncluded = dataFromNavigation?.find(
        (item: any) => item.includeRandomPayment
      )?.includeRandomPayment;
      setIncludeAdditionalPayment(randomPaymentIncluded);
    }

    // --- Filter Data Mapping ---
    const filterBranches = branches?.filter(
      (item: any) => item?.country === countryCheck
    );
    const filterBatches = batchList?.filter(
      (batch: any) =>
        batch.batchConductType === "REGULAR_BATCH" &&
        batch.batchStatus !== "CANCELLED" &&
        batch.status === "ACTIVE" &&
        (hasAllBranchAccess || batch.branchId === userById?.branchId) &&
        filterBranches?.some((branch: any) => branch.id === batch.branchId)
    );

    // --- Set months/year ---
    if (month && !add) {
      const grouped = month?.reduce((acc: any, item: any) => {
        const [m, y] = item.split("-").map(Number);
        const found = acc.find((entry: any) => entry.year === y);
        if (found) found.month.push(m);
        else acc.push({ year: y, month: [m] });
        return acc;
      }, []);
      setSelectedMonths({ monthYear: grouped });
    }

    if (reportSubType) setReportType(reportSubType);
    if (countryCheck) {
      setCheckedCountry([{ name: countryCheck }]);
      setAppliedCountry([{ name: countryCheck }]);
    }

    // --- Branches ---
    if (
      branchIdArray === "ALL" ||
      branchIdArray?.length === filterBranches?.length
    ) {
      const allBranches =
        filterBranches?.map((d: any) => ({
          id: d.id,
          branchName: d.branchName,
        })) || [];
      setCheckedBranches([...allBranches]);
    } else {
      const aa = branchIdArray?.map((d: any) => ({
        id: d,
        branchName: findNamesbyId("BRANCH", d),
      }));
      setCheckedBranches(aa);
    }

    // --- Batches ---
    if (
      batchIdArray === "ALL" ||
      batchIdArray?.length === filterBatches?.length
    ) {
      const allBatches =
        filterBatches?.map((d: any) => ({
          id: d.id,
          batchName: d.batchName,
        })) || [];
      setCheckedBatches([...allBatches]);
    } else {
      const aa = batchIdArray?.map((d: any) => ({
        id: d,
        batchName: findNamesbyId("BATCH", d),
      }));
      setCheckedBatches(aa);
    }

    // --- Courses ---
    if (courseIdArray === "ALL") {
      const allCourses =
        coursesList?.map((d: any) => ({
          id: d.id,
          courseName: d.courseName,
        })) || [];
      setCheckedCourses([...allCourses]);
    } else {
      const aa = courseIdArray?.map((d: any) => ({
        id: d,
        courseName: findNamesbyId("COURSE", d),
      }));
      setCheckedCourses(aa);
    }

    setActive(0);
    // ✅ only re-run when data is actually fetched
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportWholeData?.appliedFilter, reportById?.reportData?.appliedFilter]);

  React.useEffect(() => {
    if (saveReportSuccess !== false && saveReportSuccess !== false) {
      dispatch(resetReportStatuses());
      dispatch(resetWholeReportData());
      navigate(`/app/Reports/RecentReports`);
    }
  }, [saveReportSuccess]);

  const onTypeChange = React.useCallback((event: any, value: any) => {
    setSelectedType((prev) => {
      const newItemsMap = new Map(value?.map((item: any) => [item.id, item]));

      return prev
        ?.filter((value) => newItemsMap.has(value.id))
        ?.concat(
          value.filter(
            (item: any) => !prev.some((prevItem) => prevItem.id === item.id)
          )
        );
    });
  }, []);
  console.log(
    "LL",
    reportById?.reportData?.lineGraphData?.labels?.length,
    reportWholeData?.lineGraphData?.labels?.length
  );
  return (
    <Box
      sx={{
        overflow: "hidden",
        padding: "14px 16px",
        background: "#EEEEEE",
        maxHeight: "calc(100vh - 85px)",
        position: "relative",
        scrollbarWidth: "none",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#F5F5F5",
          display: "flex",
          width: "100%",
          maxHeight: "calc(100vh - 85px)",
          minHeight: "calc(100vh - 85px)",
          scrollbarWidth: "none",
        }}
      >
        <Box
          sx={{
            background: "#fff",
            width: "100%",
          }}
        >
          {(add && reportWholeData === null) || reportByIdLoading ? (
            <div style={{ padding: "10px 20px" }}>
              <Skeleton animation="wave" variant="rectangular" height={100} />
            </div>
          ) : (
            <div className={styles.batchHeader}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                {!add && (
                  <PageBackBtn
                    onClick={() => {
                      pageBack();
                    }}
                    iconOnly={true}
                  />
                )}

                <div className={styles.headerText}>
                  {add ? "Reports - Revenue" : `${reportById?.name}`}
                </div>
                <div className={styles.filterContainerForRevenue}>
                  <Button
                    variant="contained"
                    onClick={handleClick}
                    endIcon={<ArrowDropDownIcon />}
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                    disabled={!add}
                  >
                    {reportType?.replace(/_/g, " ").toLowerCase()}
                  </Button>

                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => handleClose(null)}
                    PaperProps={{
                      style: {
                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                        borderRadius: "4PX",
                        border: "1px solid #E4E4E7",
                      },
                    }}
                  >
                    {[{ value: "MONTH_LEVEL" }, { value: "BATCH_LEVEL" }]?.map(
                      (item: any, index: number) => (
                        <MenuItem
                          key={index}
                          onClick={() => handleReportType(item?.value)}
                          sx={{
                            textTransform: "capitalize",
                            color: "rgb(102, 112, 133)",
                          }}
                        >
                          {item?.value?.replace(/_/g, " ").toLowerCase()}
                        </MenuItem>
                      )
                    )}
                  </Menu>
                </div>
                <button
                  className={styles.filterShowBtn}
                  onClick={() => setShowFilters(!showFilters)}
                >
                  Filters{" "}
                  <img
                    src={accordionDown}
                    alt="accordionDown"
                    style={{
                      marginLeft: "5px",
                      transform: showFilters ? "rotate(180deg)" : "none",
                      transition: "0.2s ease-in-out",
                    }}
                  />
                </button>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <button
                  className={styles.graphCollapseBtn}
                  onClick={() => setCollapseGraph(!collapseGraph)}
                >
                  Graph{" "}
                  <img
                    src={accordionDown}
                    alt=""
                    style={{
                      marginLeft: "5px",
                      transform: collapseGraph ? "rotate(180deg)" : "none",
                      transition: "0.2s ease-in-out",
                    }}
                  />
                </button>
                {add && (
                  <>
                    <CancelBtn
                      onClick={() => {
                        setCancel(true);
                      }}
                    />
                    <SaveBtn
                      onClick={() => {
                        setOpenSaveReportPopup(true);
                      }}
                    />
                    {(reportWholeData?.overDue?.length > 0 ||
                      reportWholeData?.paymentData?.length > 0) && (
                      <button
                        className={styles.downloadBtn}
                        onClick={() => handleDownload()}
                        disabled={downloadLoading}
                      >
                        {downloadLoading ? (
                          <CircularProgress size={18} color={"inherit"} />
                        ) : (
                          <img src={downloadIcon} alt="downloadIcon" />
                        )}
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          )}

          <div
            style={{
              overflowY: "scroll",
              maxHeight: "calc(100vh - 178px)",
              height: "calc(100vh - 178px)",
              padding: "0 20px",
            }}
          >
            {(add && reportWholeData === null) || reportByIdLoading ? (
              <>
                <Skeleton animation="wave" variant="rectangular" height={200} />
              </>
            ) : (
              <>
                <div
                  className={styles.reportFilterWrap}
                  style={{ display: showFilters ? "flex" : "none" }}
                >
                  <div className={styles.reportFilterFields}>
                    <div>
                      {add ? (
                        <AutoCompleteFilter
                          options={filteredCountries?.map((item: any) => ({
                            name: item.name,
                          }))}
                          value={checkedCountry}
                          onChange={onCountryChange}
                          listType={"COUNTRY"}
                          label={"Country"}
                          multiSelect={true}
                          disableClearable={true}
                        />
                      ) : (
                        <>
                          <div className={styles.filterChipLbel}>Country</div>
                          <div className={styles.filterChipsWrap}>
                            {checkedCountry?.length > 0 &&
                              checkedCountry?.map((item, index: number) => (
                                <FilterChips
                                  key={`${item.name}-${index}`}
                                  keyVal={`${item.name}-${index}`}
                                  chipName={item.name?.toLowerCase()}
                                  clearBtn={false}
                                />
                              ))}
                          </div>
                        </>
                      )}
                    </div>
                    <div>
                      {add ? (
                        <AutoCompleteFilter
                          options={filteredBranches?.map((item: any) => ({
                            id: item.id,
                            branchName: item.branchName,
                          }))}
                          value={checkedBranches}
                          onChange={
                            // reportType === "BATCH_LEVEL"
                            //   ? onSingleBranchChange
                            //   :
                            onBranchChange
                          }
                          listType={"BRANCH"}
                          label={"Branch"}
                          multiSelect={true}
                          disableClearable={true}
                        />
                      ) : (
                        <>
                          <div className={styles.filterChipLbel}>Branch</div>
                          <div className={styles.filterChipsWrap}>
                            {checkedBranches?.length > 0 &&
                              checkedBranches?.map((item, index: number) => (
                                <FilterChips
                                  key={item?.id}
                                  keyVal={item?.id}
                                  chipName={item.branchName?.toLowerCase()}
                                  clearBtn={false}
                                />
                              ))}
                          </div>
                        </>
                      )}
                    </div>

                    {reportType === "MONTH_LEVEL" ? (
                      <>
                        {/* <div>
                          {add ? (
                            // <AutoCompleteFilter
                            //   options={getYears(
                            //     moment().year() - 10,
                            //     moment().year()
                            //   ).reverse()}
                            //   value={selectedYear}
                            //   onChange={onYearChange}
                            //   listType={"YEAR"}
                            //   label={"Year"}
                            //   multiSelect={true}
                            //   disableClearable={true}
                            // />

                            <></>
                          ) : (
                            <>
                              <div className={styles.filterChipLbel}>Year</div>
                              <div className={styles.filterChipsWrap}>
                                {selectedYear?.length > 0 &&
                                  [selectedYear]?.map((item, index: number) => (
                                    <FilterChips
                                      key={`${item}-${index}`}
                                      keyVal={`${item}-${index}`}
                                      chipName={item?.toString()}
                                      clearBtn={false}
                                    />
                                  ))}
                              </div>
                            </>
                          )}
                        </div> */}
                        {/* <div>
                          {add ? (
                            // <AutoCompleteFilter
                            //   options={getMonths()}
                            //   value={selectedMonth}
                            //   onChange={onMonthChange}
                            //   listType={"MONTH"}
                            //   label={"Month"}
                            //   multiSelect={true}
                            //   disableClearable={true}
                            // />
                            // <YearMonthSelector />
                            <></>
                          ) : (
                            <>
                              <div className={styles.filterChipLbel}>Month</div>
                              <div className={styles.filterChipsWrap}>
                                {selectedMonth?.length > 0 &&
                                  selectedMonth?.map((item, index: number) => (
                                    <FilterChips
                                      key={`${item?.value}-${index}`}
                                      keyVal={`${item?.value}-${index}`}
                                      chipName={item?.value}
                                      clearBtn={false}
                                    />
                                  ))}
                              </div>
                            </>
                          )}
                        </div> */}
                        <div
                          style={{
                            display: "flex",
                            fontSize: "14px",
                            alignItems: "center",
                            margin: "10px 10px 10px 0px",
                            fontWeight: "500px",
                          }}
                        >
                          <Checkbox
                            sx={{
                              strokeWidth: 1,
                              color: "rgba(102, 112, 133, 0.30)",
                            }}
                            checked={includeAdditionaPayment}
                            onChange={(event: any) => {
                              setIncludeAdditionalPayment(event.target.checked);
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                            disabled={!add}
                          />
                          Include Additional Payments
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          {add ? (
                            <AutoCompleteFilter
                              options={coursesList?.map((item: any) => ({
                                id: item.id,
                                courseName: item.courseName,
                              }))}
                              value={checkedCourses}
                              onChange={onCourseChange}
                              listType={"COURSE"}
                              label={"Course"}
                              multiSelect={true}
                              disableClearable={true}
                            />
                          ) : (
                            <>
                              <div className={styles.filterChipLbel}>
                                Course
                              </div>
                              <div className={styles.filterChipsWrap}>
                                {checkedCourses?.length > 0 &&
                                  checkedCourses?.map((item, index: number) => (
                                    <FilterChips
                                      key={item?.id}
                                      keyVal={item?.id}
                                      chipName={item?.courseName}
                                      clearBtn={false}
                                    />
                                  ))}
                              </div>
                            </>
                          )}
                        </div>
                        <div>
                          {add ? (
                            <AutoCompleteFilter
                              options={filteredBatch?.map((item: any) => ({
                                id: item.id,
                                batchName: item.batchName,
                                isBatchCompleted:
                                  item?.batchStatus === "COMPLETED",
                              }))}
                              value={checkedBatches}
                              onChange={onBatchChange}
                              listType={"BATCH"}
                              label={"Batch"}
                              multiSelect={true}
                              disableClearable={true}
                            />
                          ) : (
                            <div>
                              <div className={styles.filterChipLbel}>Batch</div>
                              <div className={styles.filterChipsWrap}>
                                {checkedBatches?.length > 0 &&
                                  checkedBatches?.map((item, index: number) => (
                                    <FilterChips
                                      key={item?.id}
                                      keyVal={item?.id}
                                      chipName={item?.batchName}
                                      clearBtn={false}
                                    />
                                  ))}
                              </div>
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            fontSize: "14px",
                            alignItems: "center",
                            margin: "10px 10px 10px 0px",
                            fontWeight: "500px",
                          }}
                        >
                          <Checkbox
                            sx={{
                              strokeWidth: 1,
                              color: "rgba(102, 112, 133, 0.30)",
                            }}
                            checked={includeAdditionaPayment}
                            onChange={(event: any) => {
                              setIncludeAdditionalPayment(event.target.checked);
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                            disabled={!add}
                          />
                          Include Additional Payments
                        </div>
                      </>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      {add ? (
                        <AutoCompleteFilter
                          options={typeOptions}
                          value={selectedType}
                          onChange={onTypeChange}
                          listType={"TYPE"}
                          label={"Status"}
                          multiSelect={true}
                          disableClearable={true}
                        />
                      ) : (
                        <div>
                          <div className={styles.filterChipLbel}>Status</div>
                          <div className={styles.filterChipsWrap}>
                            {selectedType?.length > 0 &&
                              selectedType?.map((item, index: number) => (
                                <FilterChips
                                  key={`${item?.value}-${index}`}
                                  keyVal={`${item?.value}-${index}`}
                                  chipName={item?.value}
                                  clearBtn={false}
                                />
                              ))}
                          </div>
                        </div>
                      )}
                      {reportType === "MONTH_LEVEL" && (
                        <>
                          {add ? (
                            <YearMonthSelector
                              hoveredYear={hoveredYear}
                              setHoveredYear={setHoveredYear}
                              selectedMonths={selectedMonths}
                              setSelectedMonths={setSelectedMonths}
                            />
                          ) : (
                            <div>
                              <div className={styles.filterChipLbel}>
                                Selected Year and Months
                              </div>
                              <div className={styles.filterChipsWrap}>
                                {selectedMonths?.monthYear?.map(
                                  (item: any, i: any) => (
                                    <div
                                      key={i}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          color: "black",
                                          fontWeight: "600px",
                                        }}
                                      >
                                        {item.year}
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                          width: "250px",
                                        }}
                                      >
                                        {item.month.map((m: any, idx: any) => (
                                          <FilterChips
                                            key={`${item.year}-${m}-${idx}`}
                                            keyVal={`${item.year}-${m}`}
                                            chipName={`${numberToMonthName[m]}`}
                                            clearBtn={false}
                                          />
                                        ))}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {add && (
                    <div className={styles.filterBtnWrap}>
                      <SaveBtn
                        buttonText={"Apply"}
                        onClick={() => {
                          handleFilterApply();
                        }}
                        loader={reportDataloading}
                        disabled={reportDataloading || selectedType.length < 1}
                      />
                      <button
                        className={styles.clearBtn}
                        onClick={() => handleResetFilter()}
                      >
                        <img src={clearFilterIcon} alt="clearFilterIcon" />
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}

            <div
              className={styles.graphContainer}
              style={{ display: collapseGraph ? "flex" : "none" }}
            >
              {reportDataloading || reportByIdLoading ? (
                <DashboardSkeleton />
              ) : (
                <>
                  <div
                    className={styles.lineGraphForRevenueContainer}
                    style={{ width: "100%", marginLeft: "0px" }}
                  >
                    <div className={styles.countContainer}>
                      <div className={styles.countBox}>
                        <div className={styles.receivedHeader}>
                          Total Received
                        </div>
                        <div
                          className={styles.receivedCount}
                          style={{
                            fontFamily: "Roboto",
                            direction: [
                              "Arabic",
                              "Hebrew",
                              "Urdu",
                              "Farsi",
                            ].some((lang) =>
                              findCountryByName(
                                appliedCountry?.[0]?.name,
                                countries
                              )?.languages?.includes(lang)
                            )
                              ? "rtl"
                              : "ltr",
                          }}
                        >
                          {
                            findCountryByName(
                              appliedCountry?.[0]?.name,
                              countries
                            )?.currencies?.[0]?.symbol
                          }
                          {!add
                            ? formatAmount(
                                reportById?.reportData?.totalPaidRevenue
                              )
                            : formatAmount(reportWholeData?.totalPaidRevenue)}
                        </div>
                      </div>
                      <div className={styles.countBox}>
                        <div className={styles.receivedHeader}>
                          Total Overdue
                        </div>
                        <div
                          className={styles.receivedCount}
                          style={{
                            direction: [
                              "Arabic",
                              "Hebrew",
                              "Urdu",
                              "Farsi",
                            ].some((lang) =>
                              findCountryByName(
                                appliedCountry?.[0]?.name,
                                countries
                              )?.languages?.includes(lang)
                            )
                              ? "rtl"
                              : "ltr",
                            fontFamily: "Roboto",
                          }}
                        >
                          {
                            findCountryByName(
                              appliedCountry?.[0]?.name,
                              countries
                            )?.currencies?.[0]?.symbol
                          }
                          {!add
                            ? formatAmount(
                                reportById?.reportData?.totalOverdueRevenue
                              )
                            : formatAmount(
                                reportWholeData?.totalOverdueRevenue
                              )}
                        </div>
                      </div>
                    </div>

                    <div
                      className={styles.lineGraphForRevenueContainerInsider}
                      style={{
                        overflowX: "auto",
                      }}
                    >
                      <div
                        style={{
                          minWidth:
                            reportById?.reportData?.lineGraphData?.labels
                              ?.length > 25 ||
                            reportWholeData?.lineGraphData?.labels?.length > 25
                              ? `${
                                  !add
                                    ? reportById?.reportData?.lineGraphData
                                        ?.labels.length * 50
                                    : reportWholeData?.lineGraphData?.labels
                                        .length * 50
                                }px`
                              : "100%",
                          height: "300px",
                        }}
                      >
                        <BarChart
                          data={
                            !add
                              ? reportById?.reportData?.lineGraphData?.datasets
                              : reportWholeData?.lineGraphData?.datasets
                          }
                          labels={
                            !add
                              ? reportById?.reportData?.lineGraphData?.labels
                              : reportWholeData?.lineGraphData?.labels
                          }
                          place={"REVENUE_REPORT"}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className={styles.leadsTableContainer}>
              {reportDataloading || reportByIdLoading ? (
                <>
                  <TableSkeleton />
                </>
              ) : (
                <>
                  <div className={styles.toggleContainer}>
                    <PaymentStatusToggle
                      active={active}
                      setActive={setActive}
                    />
                  </div>
                  {active === 0 && (
                    <RevenuePaidTab
                      tableData={
                        add
                          ? reportWholeData?.paymentData
                          : reportById?.reportData?.paymentData
                      }
                      id={activeInstitute?.id}
                    />
                  )}
                  {active === 1 && (
                    <RevenueOverdueTab
                      tableData={
                        add
                          ? reportWholeData?.overDue
                          : reportById?.reportData?.overDue
                      }
                      id={activeInstitute?.id}
                    />
                  )}
                  {active === 2 && (
                    <RevenuePendingTab
                      tableData={
                        add
                          ? reportWholeData?.pendingdata
                          : reportById?.reportData?.pendingdata
                      }
                      id={activeInstitute?.id}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </Box>
      </Box>
      {openSaveReportPopup && (
        <SaveReportPopup
          openSaveReportPopup={openSaveReportPopup}
          setOpenSaveReportPopup={setOpenSaveReportPopup}
          handleSaveClick={handleSaveClick}
          saveReportLoading={saveReportLoading}
          description={description}
          setDescription={setDescription}
          reportName={reportName}
          setReportName={setReportName}
        />
      )}
      <CancelModal
        open={cancel}
        onClose={onCancel}
        noButtonClick={noCancelModal}
        yesButtonClick={yesCancelModal}
        subTitle=""
        title={`Do you really want to close the report without saving it!!!`}
      />
    </Box>
  );
};

export default RevenueReportCreation;
